import { MapPin, Mail, Phone } from "lucide-react";

export default function Contact() {
    return (
        <section className="contact-wrap">

            <div className="contact-box">

                <div className="contact-banner">

                    <div className="contact-banner-content">
                        <span className="contact-label">CONTACT US</span>
                        <h2>
                            Talk To The Team <br />
                            Behind Gulmohar Pulses
                        </h2>
                        <span className="contact-tagline">From Farm to Packaging</span>
                    </div>

                </div>


                {/* Content */}
                <div className="contact-grid">

                    {/* LEFT INFO CARD */}
                    <div className="contact-info-card">
                        <div className="info-item">
                            <div className="icon-circle">
                                <MapPin size={18} />
                            </div>
                            <div>
                                <h4>Location</h4>
                                <p>
                                    Near Nabagarh Gate, Main Road,<br />
                                    Ajnaur Khas, Tikamgarh,<br />
                                    Madhya Pradesh – 472010
                                </p>
                            </div>
                        </div>


                        <div className="info-item">
                            <div className="icon-circle">
                                <Mail size={18} />
                            </div>
                            <div>
                                <h4>Email Us</h4>
                                <p>info.rqi@rajbhartifoods.com</p>
                                <p>rajbhartiquartzite@gmail.com</p>
                            </div>
                        </div>

                        <div className="info-item">
                            <div className="icon-circle">
                                <Phone size={18} />
                            </div>
                            <div>
                                <h4>Phone</h4>
                                <p>
                                    +91 9685818828
                                </p>
                            </div>
                        </div>
                        {/* SOCIAL LINKS */}
                        <div className="contact-socials-wrap">
                            <span className="social-label">Follow us on</span>

                            <div className="contact-socials left">
                                <a
                                    href="https://www.instagram.com/gulmoharrbq?igsh=MTgzZDI1amVqcGN4ZQ%3D%3D&utm_source=qr"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="social-icon"
                                    aria-label="Instagram"
                                >
                                    <i className="fab fa-instagram"></i>
                                </a>

                                <a
                                    href="https://www.linkedin.com/company/rajbharti-quartzite-industries-private-limited/"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="social-icon"
                                    aria-label="LinkedIn"
                                >
                                    <i className="fab fa-linkedin-in"></i>
                                </a>
                            </div>
                        </div>


                    </div>

                    {/* RIGHT CTA CARD */}
                    <div className="contact-cta-card">
                        <h3>Get In Touch With Rajbharti Quartzite Industries</h3>
                        <p>
                            For product inquiries, bulk orders, distribution,
                            or partnerships — our team is always ready to help.
                        </p>

                        <div className="cta-actions">
                            <a href="tel:+918878248828" className="cta-btn">
                                Call Now →
                            </a>
                            <a
                                href="mailto:rajbhartiquartzite@gmail.com"
                                className="cta-btn outline"
                            >
                                Send Email
                            </a>
                        </div>
                        <span className="cta-note">
                            <span className="tick-circle">✔</span>
                            <span className="cta-text">Purity in Every Grain</span>
                        </span>

                    </div>

                </div>

            </div>
        </section>
    );
}
